const enums = {
  stockStatus: {
    staged: "Staged",
    available: "Available",
    approval: "Approval",
    issued: "Issued",
    unAvailable: "Unavailable",
  },

  orderStatus: {
    inReview: "In review",
    accepted: "Accepted",
    making: "Making",
    dispatched: "Dispatched",
    delivered: "Delivered",
    canceled: "Canceled",
  },

  keywords: {
    selectAll: "Select All",
    includedUsers: {
      public: "All Unregistered Users",
      private: "All Registered Users",
    },
    dataEngine: "Data-Engine",
  },

  workflow: {
    wholesale: "Wholesale",
    productWise: "Product Wise",
  },

  roles: {
    superAdmin: "Super Admin",
    admin: "Admin",
    customer: "Customer",
    manager: "Inventory Manager",
    salesPerson: "Sales Person",
    branch: "Branch",
    zoneManager: "Zone Manager",
    inventoryManager: "Inventory Manager",
    vendor: "Vendor",
    regular: "Regular",
  },

  fieldTypes: {
    textField: "textField",
    dropdown: "dropdown",
    upload: "upload",
  },
  models: {
    iam: {
      clients: "iam/clients",
      users: "iam/users",
    },

    products: "data-engine/products",
    collectionLines: "data-engine/collectionLines",
    category: "data-engine/category",
    subCategory: "data-engine/subCategory",
    alerts: "e-creatives/alerts",
    carts: "e-creatives/carts",
    overviews: "e-creatives/overviews",
    groups: "e-creatives/groups",
    catalogues: "e-creatives/catalogues",
    orders: "e-creatives/orders",
    users: "e-creatives/users",
  },

  mobileAppScreenNames: {
    home: "Home",
    productsList: "Products List",
    productDetail: "Product Detail",
    wishList: "Wish List",
    cart: "Cart",
    orders: "Orders Group",

    signin: "Signin",
    signup: "Signup",
  },

  designPatterns: ["Default", "Greenish"],

  productsImportKey: {
    sku: "SKU",
    collectionLine: "Collection Line",
    category: "Category",
    subCategory: "Sub Category",
    styleNo: "Style No",
    grossWeight: "Gross Weight",
    netWeight: "Net Weight",
    stockStatus: "Stock Status",
  },

  asyncStorage: {
    fcmToken: "fcmToken",
    userDetails: "userDetails",
    token: "token",
    overview: "overview",
    cartItems: "cartItems",

    wishes: "wishes",

    products: "products",
    categories: "categories",
    groups: "groups",
  },
};

export default enums;
